/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import LayoutPortalElement from "../layouts/LayoutPortalElements";

const captivePortalLayout = ({
  template,
  content,
  rowHeight,
  selectedId,
  fields = {},
  preview = false,
  fullPreview = false,
  mini = false,
}) => {
  return template.map((template) => {
    // get item config
    const id = template.i;
    const itemContent = content.find((content) => content.i === id);
    const config = itemContent?.config
    
    // handle invalid config
    if (config == null) {
      return null;
    }

    // get template element
    return (
      <div className="d-flex" key={template.i}>
        <LayoutPortalElement
          key={template.i}
          type={itemContent.type}
          config={config}
          fields={fields}
          rowHeight={rowHeight}
          preview={preview}
          fullPreview={fullPreview}
          mini={mini}
          selected={selectedId != null && selectedId === id}
        />
      </div>
    );
  });
};

export default captivePortalLayout;
